import React from "react";
import Select from "react-select";

function Input({
  isMutli = false,
  label,
  type,
  name,
  placeholder,
  options = [],
  formData,
  setFormData,
}) {
  const handleChange = (selectedOptions) => {
    if (isMutli) {
      // Store full selected options for multi-select
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedOptions || [], // Store full options
      }));
    } else {
      console.log(selectedOptions);
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedOptions ,
      }));
    }
  };

  // Get the current value for the Select component
  const getCurrentValue = () => {
    if (isMutli) {
      // For multi-select, return the full selected options
      return formData[name] || [];
    } else {
      // For single-select, find the matching option
      return options.find((option) => option.value === formData[name]?.value) || null;
    }
  };

  return (
    <div className="flex flex-col gap-y-1 mt-2">
      <div>
        <label htmlFor={name}>{label}</label>
      </div>
      {type === "select" ? (
        <Select
          isMulti={isMutli}
          value={getCurrentValue()} // Set the correct value
          options={options}
          onChange={handleChange}
          name={name}
          isSearchable
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              borderColor: "gray",
              "&:hover": {
                borderColor: "gray",
              },
            }),
          }}
        />
      ) : (
        <input
          value={formData[name] || ""}
          type={type}
          name={name}
          id={name}
          placeholder={placeholder}
          onChange={(e) =>
            setFormData((prevData) => ({
              ...prevData,
              [name]: e.target.value,
            }))
          }
          className="border-2 border-gray-300 rounded-md p-2 focus:border-indigo-500 duration-500"
        />
      )}
    </div>
  );
}

export default Input;